import { Controller } from "@hotwired/stimulus"

// Floating flash message that dismisses itself. Exits on a timer, on click,
// or when Turbo swaps the page out from under it.
export default class extends Controller {
  static values = { delay: { type: Number, default: 2000 } }

  connect() {
    requestAnimationFrame(() => this.element.classList.add("toast-visible"))
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.removal)
  }

  dismiss() {
    clearTimeout(this.timer)
    this.element.classList.remove("toast-visible")
    this.element.classList.add("toast-leaving")
    // Matches the .toast transition duration; remove so stacked toasts reflow.
    this.removal = setTimeout(() => this.element.remove(), 300)
  }
}
